module.exports = __webpack_public_path__ + "img/logo.96c8491.png";